var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section",attrs:{"id":"functions"}},[_c('div',{directives:[{name:"t",rawName:"v-t",value:('title.functions'),expression:"'title.functions'"}],staticClass:"title text-center q-mb-lg"}),_c(_vm.$q.screen.gt.sm ? 'FunctionsCardsDesktop' : 'FunctionsCardsMobile',{tag:"component",attrs:{"items":_vm.$options.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }